export interface DemoUser {
  key?: string;
  name?: string;
  role?: string;
  email?: string;
  showTitle?: boolean;
  showDivider?: boolean;
}

/**
 * Same derivation DemoUserSwitcher (v1) uses on click — the Menu item `key`
 * (`user.key`, NOT `user.email`, which v1 never reads), resolved against the
 * shared @eduvo.com demo domain when it isn't already a full address.
 * Exported so the v4 demo switcher resolves identical addresses — do not
 * fork this rule.
 */
export const resolveDemoUserEmail = (user: DemoUser): string | undefined => {
  if (!user.key) return undefined;
  return user.key.includes('@') ? user.key : `${user.key}@eduvo.com`;
};

export const DEMO_USERS: DemoUser[] = [
  { key: 'sharon', name: 'Sharon Arese', role: 'Admin', email: 'sharon@eduvo.com' },
  { key: 'risa', name: 'Risa Aoki', role: 'Teacher', email: 'risa@eduvo.com' },
  { key: 'chloe', name: 'Chloe Epelbaum', role: 'DP Student', email: 'chloe@eduvo.com' },
  { key: 'david', name: 'David Etuhu', role: 'DP Student', email: 'david@eduvo.com' },
  {
    key: 'rachel.epelbaum',
    name: 'Rachel Epelbaum',
    role: 'MYP Student',
    email: 'rachel.epelbaum@eduvo.com',
  },
  { showTitle: true, showDivider: true, name: 'Demo District Network' },
  { key: 'district_admin@basised.com', name: 'Demo District Network Admin', role: 'Admin' },
  { key: 'district_author@basised.com', name: 'Demo District Network Author', role: 'Author' },

  { showTitle: true, showDivider: true, name: 'Demo District Network Texas' },
  { key: 'district_admin@basisedtexas.com', name: 'District Admin Texas', role: 'Admin' },
  { key: 'district_author@basisedtexas.com', name: 'District Author Texas', role: 'Author' },

  { showTitle: true, name: 'Austin' },
  { key: 'admin@basisedtexasaustin.com', name: 'Admin Texas Austin', role: 'Admin' },
  { key: 'teacher@basisedtexasaustin.com', name: 'Teacher Texas Austin', role: 'Teacher' },
  { key: 'student1@basisedtexasaustin.com', name: 'Student 1 Texas Austin', role: 'Student' },
  { key: 'student2@basisedtexasaustin.com', name: 'Student 2 Texas Austin', role: 'Student' },

  { showTitle: true, name: 'Northeast' },
  { key: 'admin@basisedtexasnortheast.com', name: 'Admin Texas Northeast', role: 'Admin' },
  {
    key: 'teacher@basisedtexasnortheast.com',
    name: 'Teacher Texas Northeast',
    role: 'Teacher',
  },
  {
    key: 'student1@basisedtexasnortheast.com',
    name: 'Student 1 Texas Northeast',
    role: 'Student',
  },
  {
    key: 'student2@basisedtexasnortheast.com',
    name: 'Student 2 Texas Northeast',
    role: 'Student',
  },

  { showTitle: true, showDivider: true, name: 'Demo District Network Arizona' },
  { key: 'district_admin@basisedarizona.com', name: 'District Admin Arizona', role: 'Admin' },

  { showTitle: true, name: 'Mesa' },
  { key: 'admin@basisedarizonamesa.com', name: 'Admin Arizona Mesa', role: 'Admin' },
  { key: 'teacher@basisedarizonamesa.com', name: 'Teacher Arizona Mesa', role: 'Teacher' },
  { key: 'student1@basisedarizonamesa.com', name: 'Student 1 Arizona Mesa', role: 'Student' },
  { key: 'student2@basisedarizonamesa.com', name: 'Student 2 Arizona Mesa', role: 'Student' },
];
